import styled from 'styled-components';

import { getRem } from './../../core';

import { DatePickerContainerBase } from './DatePickerContainerBase';

export const DateRangePickerContainer = styled(DatePickerContainerBase)`
  display: flex;
  max-width: ${getRem(300)};
  position: relative;
`;
